import React, { useEffect, useState, useContext } from "react";
import { Formik } from "formik";
import { Form, Button, InputGroup, Row } from "react-bootstrap";
import {
  CustomToolTip,
  Link,
  LoaderWrapper,
  SliderPanel,
} from "../../../components";
import SearchBar from "./SearchBar";
import { isEmpty } from "lodash-es";
import {
  getPlanGroups,
  onUpdateInputPlanGroups,
  updatePlanGroups,
} from "../../../services";
import { useDeepEffect } from "../../../abstracts";
import {
  UpdateApiMappings,
  manageMapperStore,
  setManageMapperToastInfo,
} from "../../../contexts";

const PlanGroupSlider = (props) => {
  const {
    showSlider,
    setShowSlider,
    mappingConfigurationId,
    savedPlanGroups,
    setSavedPlangroups,
    mapType,
    addedPlanGroups,
    setAddedPlanGroups,
    apiOutput,
  } = props;
  const { dispatch } = useContext(manageMapperStore);
  const [planGroup, setPlanGroup] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [addedFilteredValues, setAddedFilteredValues] = useState([]);
  const [planGroupsResponse, setPlanGroupsResponse] = useState([]);
  const [dataloading, setloading] = useState(false);

  useDeepEffect(() => {
    if (showSlider) {
      setloading(true);
      getPlanGroups({
        from: 0,
        offset: 0,
        searchInput: "",
      }).then((response) => {
        setloading(false);
        setPlanGroupsResponse(response);
      });
    }
  }, [showSlider]);

  useEffect(() => {
    const responsePayload = planGroupsResponse.map((item, index) => {
      return {
        planGroupId: item.id,
        planGroupName: item.name,
        planGroupDescription: item.description,
        count: item.count,
      };
    });
    const filteredPlanGroup = responsePayload.filter((el) => {
      return savedPlanGroups.every((f) => {
        return f.planGroupId !== el.planGroupId;
      });
    });
    setPlanGroup(filteredPlanGroup);
    setFilteredValues(filteredPlanGroup);
  }, [savedPlanGroups, planGroupsResponse]);

  useDeepEffect(() => {
    if (!isEmpty(savedPlanGroups)) {
      setAddedPlanGroups(savedPlanGroups);
      setAddedFilteredValues(savedPlanGroups);
    }
  }, [savedPlanGroups]);
  const onClose = () => {
    setShowSlider(false);
  };
  const addAllPlangroups = () => {
    setAddedPlanGroups((e) => [...planGroup, ...e]);
    setAddedFilteredValues((e) => [...planGroup, ...e]);
    setPlanGroup([]);
  };
  const removeAllPlangroups = () => {
    setPlanGroup((e) => [...addedPlanGroups, ...e]);
    setAddedPlanGroups([]);
    setAddedFilteredValues([]);
  };
  const removePlanGroupsFromPlanGroup = (data) => {
    setAddedPlanGroups(
      addedPlanGroups.filter((e) => e.planGroupId !== data.planGroupId)
    );
    setPlanGroup([data, ...planGroup]);
  };

  const setSearchPlanGroupsList = (value) => {
    if (value.length > 0) {
      const searchList = filteredValues.filter((e) =>
        e?.planGroupName?.toLowerCase().includes(value.toLowerCase())
      );
      return setPlanGroup(searchList);
    } else setPlanGroup(filteredValues);
  };

  const setSearchAddedPlanGroups = (value) => {
    if (value.length > 0) {
      const addedsearchList = addedFilteredValues.filter((e) =>
        e?.planGroupName?.toLowerCase().includes(value.toLowerCase())
      );
      return setAddedPlanGroups(addedsearchList);
    } else setAddedPlanGroups(addedFilteredValues);
  };

  const onSubmit = (payloadPlanGroups) => {
    const planGroupsList = payloadPlanGroups.map((item, index) => {
      return {
        id: item.id ?? 0,
        mappingOutputProfileId: mappingConfigurationId ?? 0,
        planGroupId: item.planGroupId,
        planGroupName: item.planGroupName,
        planGroupDescription: item.planGroupDescription,
        count: item.count,
      };
    });
    if (mappingConfigurationId) {
      if (mapType == 1 || apiOutput) {
        const updateInputPlanGroupsPayload = {
          mappingConfigurationId: mappingConfigurationId,
          planGroupProfileMappings: planGroupsList,
        };
        onUpdateInputPlanGroups(updateInputPlanGroupsPayload).then((res) => {
          setSavedPlangroups(res);
          dispatch(
            UpdateApiMappings({
              modelName: "planGroupProfiles",
              data: res,
            })
          );
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: `Update Plan Groups Succesfull`,
            })
          );
        });
      } else {
        const updatePlanGroupsPayload = {
          mappingConfigurationId: mappingConfigurationId,
          outputPlanGroupProfileMapping: planGroupsList,
        };
        updatePlanGroups(updatePlanGroupsPayload).then((res) => {
          setSavedPlangroups(res);
          dispatch(
            UpdateApiMappings({
              modelName: "outputPlanGroupProfileMappings",
              data: res,
            })
          );
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: `Update Plan Groups Succesfull`,
            })
          );
        });
      }
    } else setSavedPlangroups(planGroupsList);
    setShowSlider(false);
  };

  const addPlanGroupsToPlanGroup = (data) => {
    setAddedPlanGroups([...addedPlanGroups, data]);
    setAddedFilteredValues([...addedFilteredValues, data]);
    setPlanGroup(planGroup.filter((e) => e.planGroupId !== data.planGroupId));
  };
  const onFormSubmit = () => {};
  return (
    showSlider && (
      <Formik
        enableReinitialize
        onSubmit={onFormSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          values,
          setValues,
          ...rest
        }) => {
          return (
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={rest.submitCount > 0}
            >
              <SliderPanel isOpen={showSlider} size="75" showCancel={false}>
                <LoaderWrapper isLoading={dataloading}>
                  <div className="w-100 h-100 planSliderContainer">
                    <div
                      className="planGroupHeader"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "100%",
                        marginBottom: "30px",
                      }}
                    >
                      <div className="ml-3 mt-2 planTitle">
                        Add Plan Group Information
                      </div>
                      <div>
                        <Button variant="secondary" onClick={() => onClose()}>
                          Cancel
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => {
                            onSubmit(addedPlanGroups);
                            // showSuccesstile();
                          }}
                          className="ml-4"
                          style={{ marginRight: "0.6rem" }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>

                    <div style={{ height: "90%" }} className="addPlansContent">
                      <div
                        className="AddedPlanGroupsRight"
                        style={{ overflowY: "scroll" }}
                      >
                        <div className="marg-left-13">
                          <div className="pt-1 title-case marg-top-15 marg-bot-15">
                            Plan groups information
                          </div>
                          <div className="max-width-381">
                            <div style={{ width: "95%" }}>
                              <Form>
                                <div className="flex-search">
                                  <InputGroup>
                                    <InputGroup.Prepend>
                                      <div className="searchIconPostion">
                                        <i
                                          class="fal fa-search"
                                          aria-hidden="true"
                                        ></i>
                                      </div>
                                    </InputGroup.Prepend>

                                    <SearchBar
                                      size="md"
                                      type="search"
                                      placeholder="Search plan group name"
                                      className="PadLeftSearch"
                                      onChange={(e) =>
                                        setSearchPlanGroupsList(e.target.value)
                                      }
                                    />
                                  </InputGroup>
                                </div>
                              </Form>
                            </div>
                          </div>
                        </div>
                        <div className="smallOptions">
                          <div className="small-text w-310">
                            {planGroup.length} plan Group(s)
                          </div>
                          {planGroup.length !== 0 && (
                            <div className="small-text mr-4">
                              <Link
                                className="link primary-small"
                                onClick={() => addAllPlangroups()}
                              >
                                Add all
                              </Link>
                            </div>
                          )}
                        </div>

                        <div
                          style={{ width: "95%", height: "100%" }}
                          className="AddPlanTiles"
                        >
                          {planGroup.map((data, index) => (
                            <Row>
                              <div
                                style={{ width: "90%", marginBottom: "5px" }}
                                className="tile"
                              >
                                <div className="tile-text pad-left-15">
                                  <div className="tile-title add-plans-card-text">
                                    <CustomToolTip
                                      className="tile-title"
                                      displayText={`${data.planGroupName} `}
                                    />
                                    <div className="tile-number">
                                      <div className="d-flex">
                                        {data.planGroupDescription && (
                                          <CustomToolTip
                                            displayText={`${data.planGroupDescription} `}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <Link className="ml-auto mr-3">
                                  <div className="Arrow">
                                    <i
                                      className="fa fa-long-arrow-right"
                                      aria-hidden="true"
                                      onClick={() =>
                                        addPlanGroupsToPlanGroup(data)
                                      }
                                    ></i>
                                  </div>
                                </Link>
                              </div>
                            </Row>
                          ))}
                        </div>
                      </div>
                      <div
                        style={{ width: "50%", paddingLeft: "10px" }}
                        className="maintenancePlanGroupRight"
                      >
                        <div className="maintenancePlanRight-1">
                          <div className="title-case marg-top-15 marg-bot-15  ">
                            Added plan groups
                          </div>
                          <div style={{ width: "98%" }}>
                            <Form>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <div className="search-icon-postion">
                                    <i
                                      class="fal fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </InputGroup.Prepend>
                                <SearchBar
                                  size="md"
                                  type="search"
                                  placeholder="Search plan group name"
                                  onChange={(e) =>
                                    setSearchAddedPlanGroups(e.target.value)
                                  }
                                  className="pad-left-search"
                                />
                              </InputGroup>
                            </Form>
                          </div>

                          <div
                            style={{ width: "100%" }}
                            className="plan-group-remove-count"
                          >
                            {addedPlanGroups.length !== 0 && (
                              <div className="mb-2 plan-group-remove">
                                <Link
                                  className="link red-small"
                                  onClick={() => removeAllPlangroups()}
                                >
                                  Remove all
                                </Link>
                              </div>
                            )}

                            <div className="plan-group-plan mr-3">
                              {addedPlanGroups.length} Plan Group(s)
                            </div>
                          </div>

                          {isEmpty(addedPlanGroups) ? (
                            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100 ft-12">
                              <p className="mb-0">No plan groups added</p>

                              <p className="addPlanss">
                                Please add plan groups by clicking on the arrow
                              </p>
                            </div>
                          ) : (
                            <div
                              style={{ width: "100%" }}
                              className="added-plans-list"
                            >
                              {addedPlanGroups.map((data, index) => (
                                <Row>
                                  <div
                                    style={{
                                      width: "95%",
                                      marginBottom: "5px",
                                    }}
                                    className="tile-added"
                                  >
                                    <Link>
                                      <div className="Arrow-left m-0 pl-3">
                                        <i
                                          className="fa fa-long-arrow-left"
                                          aria-hidden="true"
                                          onClick={() =>
                                            removePlanGroupsFromPlanGroup(data)
                                          }
                                        ></i>
                                      </div>
                                    </Link>
                                    <div className="tile-text-added w-380">
                                      <div className="d-flex w-100">
                                        <div
                                          style={{
                                            maxWidth: "12.5rem",
                                            overflow: "visible",
                                          }}
                                        >
                                          <CustomToolTip
                                            maxWidth="12.75rem"
                                            className="tile-title"
                                            displayText={`${data.planGroupName}`}
                                          />
                                          <div className="ml-3">
                                            {data.planGroupDescription}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Row>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </LoaderWrapper>
              </SliderPanel>
            </Form>
          );
        }}
      </Formik>
    )
  );
};
export default PlanGroupSlider;
